import React from "react";
import getStyled from "../../../hooks/getStyled";

const { styled } = getStyled();

const StyledTooltip = styled("div")(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: theme.palette.white.main,
  boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.25)",
  position: "relative",
  borderRadius: 5,
  transform: "translate(-50%, -100%)",
  "&:after": {
    content: "''",
    position: "absolute",
    bottom: "-8px",
    left: "50%",
    transform: "translateX(-50%) rotate(-45deg)",
    boxShadow: "-3px 3px 4px -3px rgba(0, 0, 0, 0.25)",
    boxSizing: "border-box",
    border: `10px solid ${theme.palette.black.main}`,
    borderColor: "transparent transparent #fff #fff",
    width: 0,
    height: 0
  },
}));

const CustomTooltip = (props) => {
  return <StyledTooltip>{props.children}</StyledTooltip>;
};

export default CustomTooltip;
